const ON_CHANGE_DEBOUNCE_TIMER = 300;
const MAX_QUANTITY = 8;
window.MAX_QUANTITY = MAX_QUANTITY;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  cartDrawerOpen: "cart-drawer-open",
  cartDrawerClose: "cart-drawer-close",
  quickBuyDrawerOpen: "quick-buy-drawer-open",
  quickBuyDrawerClose: "quick-buy-drawer-close",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};
